import moment from 'moment';

function SettingsCtrl($scope, $state, $stateParams, $q, alertService, managementUserService, ERROR_MESSAGES, organizationService, mapperService, venueService, urlService) { //eslint-disable-line
  const vm = this;

  vm.currentDateUTC = moment.utc();
  vm.loading = true;
  vm.venueId = $stateParams.venueId;
  vm.hideSidebar = function () {
    if ($state.current.name.indexOf('app.organization.settings.venue') === 0) return true;

    return false;
  };

  $scope.venuesPromise = venueService.getCurrentVenues();

  const dataPromises = [
    $scope.venuesPromise
  ];

  //open the correct sub nav accoridon
  if ($state.current.name === 'app.organization.settings.organization' ||
    $state.current.name === 'app.organization.settings.integrations' ||
    $state.current.name === 'app.organization.settings.staff' ||
    $state.current.name === 'app.organization.settings.servers' ||
    $state.current.name === 'app.organization.settings.promoters' ||
    $state.current.name === 'app.organization.settings.attributions' ||
    $state.current.name === 'app.organization.settings.microSiteConfigs' ||
    $state.current.name === 'app.organization.settings.microSiteConfigEdit') {
    vm.showCompanyLinks = true;
  }

  $q.all(dataPromises)
    .then(results => {
      vm.venues = results[0];

      vm.loading = false;
    });
}

SettingsCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$q',
  'alertService',
  'jsSdk.managementUser',
  'ERROR_MESSAGES',
  'organizationService',
  'mapperService',
  'venueService',
  'urlService'
];

export default SettingsCtrl;



// WEBPACK FOOTER //
// ./src/components/settings/settingsCtrl.js